import { BranchType } from "@/features/church/config/branches/types/branch.types"

const SYSTEM_BRANCH_NAME_PATTERN = /^SYSTEM_BRANCH_/i

export function isSystemBranchLike(
  branchType?: BranchType | string | null,
  branchName?: string | null
): boolean {
  if (branchType === BranchType.System || branchType === "SYSTEM") {
    return true
  }

  return Boolean(branchName && SYSTEM_BRANCH_NAME_PATTERN.test(branchName.trim()))
}

export function getBranchDisplayLabel(input: {
  branchType?: BranchType | string | null
  branchName?: string | null
  parishLabel: string
  fallbackLabel: string
}): string {
  const { branchType, branchName, parishLabel, fallbackLabel } = input

  if (isSystemBranchLike(branchType, branchName)) {
    return parishLabel
  }

  const trimmedName = branchName?.trim()
  if (trimmedName && trimmedName.length > 0) {
    return trimmedName
  }

  return fallbackLabel
}
